




























import { defineComponent, PropType } from '@vue/composition-api';
import { ScheduleItem } from './types';
import OlbButton from '../button';
import OlbImage from '../image';

export default defineComponent({
	components: {
		OlbButton,
		OlbImage,
	},
	props: {
		event: {
			type: Object as PropType<ScheduleItem>,
			required: true,
		},
	},
});
